import React from 'react';
import DetailsTitle from '../DetailsTitle';
import DetailsField from '../DetailsField';
import { timezoneToLabel } from '../../../../lib/date.utils';
import { PARTNER_CATEGORIES } from '../../../../constants/admin/settings';
import { selectionOptionToLabel, selectedFromOptionsToString } from '../../../../lib/collection.utils';

const PartnerShow = ({ data, contextOptions, dependencies }) => (
    <React.Fragment>
        <DetailsTitle title={data.name} image={data.image} />
        <div className="ckp-admin-forms-body">
            <div className="ckp-admin-grid-row">
                <div className="ckp-admin-grid-column is-contained is-2-3 u-full-height">
                    <div className="u-margin-bottom-3">
                        <DetailsField
                            field="Organizations"
                            value={selectedFromOptionsToString(contextOptions, data.organizationIds)}
                        />
                        <DetailsField
                            field="Events"
                            value={selectedFromOptionsToString(dependencies.events, data.eventIds)}
                        />
                        <DetailsField
                            field="Category"
                            value={selectionOptionToLabel(data.category, PARTNER_CATEGORIES)}
                        />
                    </div>
                    <div className="u-margin-bottom-3">
                        <DetailsField field="Address" value={data.address1} />
                        <DetailsField field="Address (Cont.)" value={data.address2} />
                        <DetailsField field="Postal Code" value={data.postalCode} />
                        <DetailsField field="City" value={data.city} />
                        <DetailsField field="State / Province" value={data.stateProvince} />
                        <DetailsField field="Country" value={data.country} />
                        <DetailsField field="Partner Timezone" value={timezoneToLabel(data.timeZone)} />
                    </div>
                    <div className="u-margin-bottom-3">
                        {data.socialMedia.map((sm, i) => (
                            <DetailsField key={i} field={sm.k} value={sm.v} link={`${sm.v}`} target="_blank" />
                        ))}
                    </div>
                    <div className="u-margin-bottom-3">
                        <DetailsField field="Website" value={data.website} link={data.website} target="_blank" />
                    </div>
                </div>
                <div className="ckp-admin-grid-column is-contained is-1-3 u-full-height">
                    <h3 className="ckp-ts-h3 u-bold u-margin-bottom-2">Description</h3>
                    <div>{data.description}</div>
                </div>
            </div>
        </div>
    </React.Fragment>
);

export default PartnerShow;
